module.exports = __webpack_public_path__ + "static/media/car2.55656a34.JPG";